"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Password = exports.Search = exports.TextArea = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _Input = require("./Input.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 文字輸入匡
 */
var Input = function Input(_ref) {
  var label = _ref.label,
      message = _ref.message,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      value = _ref.value,
      icon = _ref.icon,
      onKeyEnter = _ref.onKeyEnter,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? false : _ref$row,
      maxLength = _ref.maxLength,
      disabled = _ref.disabled,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_Input.UiInput, {
    className: className,
    row: row
  }, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_antd.Input, {
    onChange: onChange,
    placeholder: placeholder,
    value: value,
    prefix: icon && /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, icon),
    allowClear: true,
    onPressEnter: onKeyEnter,
    maxLength: maxLength,
    disabled: disabled
  }), message && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};

var TextArea = function TextArea(_ref2) {
  var label = _ref2.label,
      message = _ref2.message,
      onChange = _ref2.onChange,
      placeholder = _ref2.placeholder,
      value = _ref2.value,
      disabled = _ref2.disabled,
      maxLength = _ref2.maxLength;
  return /*#__PURE__*/_react.default.createElement(_Input.UiInput, null, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_antd.Input.TextArea, {
    onChange: onChange,
    placeholder: placeholder,
    value: value,
    autoSize: {
      minRows: 3,
      maxRows: 5
    },
    allowClear: true,
    disabled: disabled,
    maxLength: maxLength
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputInfo"
  }, message && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message), maxLength && /*#__PURE__*/_react.default.createElement("div", {
    className: "count"
  }, value.length, "/", maxLength)));
};

exports.TextArea = TextArea;

var Search = function Search(_ref3) {
  var onChange = _ref3.onChange,
      _ref3$onSearch = _ref3.onSearch,
      onSearch = _ref3$onSearch === void 0 ? function () {} : _ref3$onSearch,
      placeholder = _ref3.placeholder,
      value = _ref3.value,
      mode = _ref3.mode,
      disabled = _ref3.disabled;
  return /*#__PURE__*/_react.default.createElement(_Input.UiInput, {
    className: mode
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    onChange: onChange,
    onSearch: onSearch,
    placeholder: placeholder,
    value: value,
    suffix: /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "search"),
    allowClear: true,
    disabled: disabled
  }));
};

exports.Search = Search;

var Password = function Password(_ref4) {
  var label = _ref4.label,
      message = _ref4.message,
      onChange = _ref4.onChange,
      placeholder = _ref4.placeholder,
      value = _ref4.value,
      disabled = _ref4.disabled;
  return /*#__PURE__*/_react.default.createElement(_Input.UiInput, null, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_antd.Input.Password, {
    onChange: onChange,
    placeholder: placeholder,
    value: value,
    prefix: /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock_outline"),
    iconRender: function iconRender(visible) {
      return visible ? /*#__PURE__*/_react.default.createElement(_icons.EyeTwoTone, null) : /*#__PURE__*/_react.default.createElement(_icons.EyeInvisibleOutlined, null);
    },
    allowClear: true,
    disabled: disabled
  }), message && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};

exports.Password = Password;
var _default = Input;
exports.default = _default;
Input.propTypes = {
  label: _propTypes.default.string,
  message: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  icon: _propTypes.default.string,
  onKeyEnter: _propTypes.default.func,
  row: _propTypes.default.bool,
  maxLength: _propTypes.default.number,
  disabled: _propTypes.default.bool
};
TextArea.propTypes = {
  label: _propTypes.default.string,
  message: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  maxLength: _propTypes.default.number
};
Search.propTypes = {
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onSearch: _propTypes.default.func,
  mode: _propTypes.default.oneOf(["default", "dark"]),
  disabled: _propTypes.default.bool
};
Password.propTypes = {
  label: _propTypes.default.string,
  message: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool
};